export default __webpack_public_path__ + "static/media/ic-dl-lecture-question-banks.ee52b032.svg";